import { createFileRoute } from "@tanstack/react-router";
import { AuthPage } from "@/components/auth-page";

export const Route = createFileRoute("/two-factor")({
	component: TwoFactorPage,
	ssr: false,
});

function TwoFactorPage() {
	return <AuthPage view="TWO_FACTOR" />;
}
